export default __webpack_public_path__ + "static/media/profile.a41c8dc4.jpg";